// extracted by mini-css-extract-plugin
export default {"footer":"style_footer__IWhTA","footerFullWidth":"style_footerFullWidth__ffGRF","inner":"style_inner__wTO77","logo":"style_logo__jf4tm"};